import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  font-size: 2.5rem;
`;
